import moment from "moment";

export function DurationTime(ticks: any) {
  const time = ticks / 60;
  const hours = Math.abs(Math.floor(time));
  const minutes = Math.floor((time - hours) * 60);
  return hours + "h" + minutes + "m";
}
export function dateDiff(startDate?: Date, endDate?: Date) {
  const sta = moment(startDate);
  const end = moment(endDate);
  const date = moment.duration(end.diff(sta));
  return `${date.hours() + date.days() * 24}h${date.minutes()}m`;
}

export function daysDiff(startDate?: Date, endDate?: Date) {
  const sta = moment(startDate).format("YYYY-MM-DD");
  const end = moment(endDate).format("YYYY-MM-DD");
  const date = moment(end).diff(moment(sta), "days");
  return date;
}
export function isWeiXin() {
  const ua = window.navigator.userAgent.toLowerCase() as any;
  if (ua.match(/MicroMessenger/i) == "micromessenger") {
    return true;
  } else {
    return false;
  }
}
export function isApp() {
  return (window as any).lch_device_info != undefined;
}

export function isOfw() {
  let ofwTest = /(ofwapp)|(app.ofw.net)|(shfriendwill.com)/gi;
  return ofwTest.test(location.host) || ofwTest.test(location.hostname);
}

const companyTextKeyMap: { [companyName: string]: { [key: string]: string } } = {
  "旭化成塑料": {
    mall_order_chengbenzhongxin: "mall_order_feiyongfudanbumen",
    mall_order_qingxuanzechengbenzhongxin: "mall_order_qingxuanzefeiyongfudanbumen",
    mall_modules_choosecostcenter_chengbenzhongxin: "mall_modules_choosecostcenter_feiyongfudanbumen",
    order_orderdetails_chengbenzhongxin: "order_orderdetails_feiyongfudanbumen",
    mall_modules_producthome_xiaofeijineshangxian: "mall_modules_producthome_dangdizhusubiaozhun",
    mall_modules_productlist_xiaofeijineshangxian: "mall_modules_productlist_dangdizhusubiaozhun",
  },
};

export function resetTextByCompany(companyName: string, key: string) {
  const matchedCompany = Object.keys(companyTextKeyMap).find(name => companyName.includes(name));
  return matchedCompany ? companyTextKeyMap[matchedCompany][key] || key : key;
}
